import PropTypes from "prop-types";
import { Wrapper } from "./TagBadge.styles";

const Tag = (props) => {
    return (
        <Wrapper
            circle={props.circle}
            className={props.className}
            style={props.style}
        >
            {props.children}
        </Wrapper>
    );
};

Tag.propTypes = {
    circle: PropTypes.bool,
    className: PropTypes.string,
    style: PropTypes.object,
    children: PropTypes.node,
};

export default Tag;
